import styled from  'styled-components';

export const StyledTimeLineSection = styled.div`
  ${({theme}) => `

      margin: ${theme.uptimeSpace[10]}px ${theme.uptimeSpace[0]};
      padding: ${theme.uptimeSpace[5]}px ${theme.uptimeSpace[0]};
      border-top: solid 1px ${theme.uptimeColors.grayScales.black};
      border-bottom: solid 1px ${theme.uptimeColors.grayScales.black};
      .acc-detail {
        display: block;
        background-color: ${theme.uptimeColors.mainTheme.background};
        padding: ${theme.uptimeSpace[7]}px ${theme.uptimeSpace[0]};
        > ul {
          margin: ${theme.uptimeSpace[0]};
          padding: ${theme.uptimeSpace[0]};
        }
        .isLoadingTimeLine{
          display: flex;
          justify-content: center;
          margin: ${theme.uptimeSpace[15]}px auto ${theme.uptimeSpace[10]}px;
          color: ${theme.uptimeColors.generalColors.icon.enabled};
        }
      }
      .timeline-header {
        min-height: auto !important;
        padding: ${theme.uptimeSpace[0]} ${theme.uptimeSpace[0]} ${theme.uptimeSpace[0]} ${theme.uptimeSpace[7]}px;
        background-color: ${theme.uptimeColors.grayScales.gray};
        .Mui-expanded,
        .MuiIconButton-edgeEnd {
          margin: ${theme.uptimeSpace[0]} !important;
        }
        .show-time {
          display: flex;
        }
        .hide-time {
          display: none;
        }
        > .Mui-expanded {
          .show-time {
            display: none;
          }
          .hide-time {
            display: flex;
          }
        }
      }
      .ttl-time {
        font-family: ${theme.uptimeFonts.primary}${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`} !important;
        display: flex;
        align-items: center;
        font-size: ${theme.uptimeFontSizes.desktop.fz3}px;
        font-weight: 700;
        .MuiSvgIcon-root {
          margin-left: ${theme.uptimeSpace[2]}px;
          font-size: ${theme.uptimeFontSizes.desktop.fz5}px;
        }
      }
      .MuiPaper-elevation1 {
        box-shadow: none;
      }
    
      .att-file {
        padding:  ${theme.uptimeSpace[0]};
        list-style-type: none;
        padding: ${theme.uptimeSpace[5]}px  ${theme.uptimeSpace[0]};
        li {
          position: relative;
          display: flex;
          align-items: flex-start;
          line-height: 1.4;
        }
        .file-name {
          padding: ${theme.uptimeSpace[0]} ${theme.uptimeSpace[12]}px ${theme.uptimeSpace[0]} ${theme.uptimeSpace[2]}px;
          font-size: ${theme.uptimeFontSizes.desktop.fz3}px;
          word-break: break-word;
          .MuiSvgIcon-root {
            position: absolute;
            z-index: 1;
            right: -5px;
            bottom: -3px;
            transform: rotate(-135deg);
          }
        }
        img {
          position: relative;
          top: -2px;
          width: 16px;
        }
      }
    

    .item-timeline {
      position: relative;
      display: block;
      margin: ${theme.uptimeSpace[7]}px ${theme.uptimeSpace[0]};
      padding-left: 70px;
      padding-right: ${theme.uptimeSpace[10]}px;
      min-height: auto !important;
      .inner {
        position: relative;
        flex: auto;
        padding: ${theme.uptimeSpace[0]};
        min-height: auto;
        .content-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-weight: bold;
          line-height: 1;
          .name {
            font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
            color: ${theme.uptimeColors.ticketColors.chatTimeline.user.titleColor};
            &.color-agent {
              color: ${theme.uptimeColors.ticketColors.chatTimeline.other.titleColor};
            }
          }
          .date {
            color: ${theme.uptimeColors.grayScales.gray};
            font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
          }
        }
        .txt-comment {
          font-size: ${theme.uptimeFontSizes.desktop.fz3}px;
          line-height: 1.4;
          word-break: break-word;
          width: 100%;
          border: none;
          background: transparent;
          resize: none;
          outline: none;
        }
        .content-body {
          margin-top: ${theme.uptimeSpace[7]}px;
        }
        .content-block {
          overflow: hidden;
          padding: ${theme.uptimeSpace[7]}px ${theme.uptimeSpace[6]}px !important;
          background-color: ${theme.uptimeColors.grayScales.white};
          border-radius: ${theme.uptimeSpace[5]}px;
          box-shadow: -${theme.uptimeSpace[2]}px ${theme.uptimeSpace[1]}px ${theme.uptimeSpace[0]} ${theme.uptimeSpace[0]} ${theme.uptimeColors.grayScales.gray};
          p {
            margin: ${theme.uptimeSpace[0]};
          }
        }
        .content-only-status {
          background-color: ${theme.uptimeColors.grayScales.darkerGray};
          .content-body {
            margin-top: ${theme.uptimeSpace[0]};
          }
          .name {
            padding-right: ${theme.uptimeSpace[5]}px;
            color: ${theme.uptimeColors.grayScales.black};
            font-size: ${theme.uptimeFontSizes.desktop.fz3}px;
          }
        }
      }
      .sb-avatar {
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 30px !important;
        height: 30px !important;
        position: absolute;
        top: 50%;
        left: -56px;
        z-index: 5;
        margin-top: -${theme.uptimeSpace[7]}px;
        text-transform: uppercase;
        font-weight: bold;
        text-align: center;
        line-height: 1;
        border-radius: 50%;
        font-size: ${theme.uptimeFontSizes.desktop.fz2}px !important;
      }
      .inner-dot {
        &:after,
        &:before {
          content: "";
          position: absolute;
          top: 50%;
          background-color: ${theme.uptimeColors.grayScales.gray};
        }
        &:after {
          left: -12px;
          z-index: 1;
          width: 8px;
          height: 8px;
          margin-top: -2px;
          border-radius: 50%;
        }
        &:before {
          left: -38px;
          z-index: 2;
          width: 30px;
          height: 1px;
        }
      }
    }

    .content-init-created {
      list-style-type: none;
      padding-left: 70px;
      padding-right: ${theme.uptimeSpace[10]}px;
      &.content-created-only {
        padding-left: ${theme.uptimeSpace[10]}px;
      }
      .content-body {
        overflow: hidden;
        margin-top: ${theme.uptimeSpace[10]}px;
        border-radius: ${theme.uptimeSpace[5]}px;
        border: solid 1px  ${theme.uptimeColors.grayScales.gray};
      }
      .tb-header,
      .tb-body {
        padding: ${theme.uptimeSpace[5]}px;
        font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
        text-align: center;
      }
      .tb-header {
        background-color:  ${theme.uptimeColors.grayScales.gray};
        border-bottom: solid 1px  ${theme.uptimeColors.grayScales.white};
        font-weight: bold;
      }
      .tb-body {
        border-top: solid 1px  ${theme.uptimeColors.grayScales.gray};
      }
    }

    .item-timeline-avatar {
      &:before {
        content: "";
        position: absolute;
        top: -20px;
        left: 29px;
        bottom: -20px;
        z-index: 3;
        width: 1px;
        background-color: ${theme.uptimeColors.grayScales.gray};
      }
      &.item-last-dot:before {
        bottom: 50% !important;
      }
      &.item-first-dot:before {
        top: 50%;
      }
    }
  `}
`;
